<template>
  <BaseModal
    :showing="visible"
    size="max-w-lg"
    :with-padding="false"
    @close="$emit('close')"
  >
    <BaseCard title="Import Promo Bundle">
      <form class="space-y-4" @submit.prevent="onSubmit">
        <BaseInput
          label="Upload File Import (.csv / .xlsx)"
          required
          type="file"
          fullwidth
          inset
          :shadow="false"
          @change="onChangeFile"
        />
        <BaseButton :loading="loading" fullwidth>
          Import
          <Icon icon="heroicons:arrow-right" />
        </BaseButton>
      </form>
    </BaseCard>
  </BaseModal>
</template>

<script>
import { requestMixin } from '../../../mixins/request/request';
import BaseModal from '../../base/BaseModal.vue';

export default {
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    productPromoId: String,
  },
  components: { BaseModal },
  emits: ['success', 'close'],
  data() {
    return {
      file: null,
      loading: false,
    };
  },
  methods: {
    onChangeFile(e) {
      this.file = e.target.files[0];
    },
    async onSubmit() {
      this.loading = true;

      const data = new FormData();

      data.append('file', this.file);

      const [, err] = await this.request(
        `/api/v1/product-promos/${this.productPromoId}/-actions/import-bundle`,
        {
          method: 'post',
          data,
        }
      );

      if (!err) {
        this.$emit('success');
      }

      this.loading = false;
    },
  },
};
</script>
